export default {
  meta: {
    title: '邀请客户'
  }
};
